import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import React from 'react'
import ReactDOM from 'react-dom/client'
import Home from './Pages/Home.jsx'
import Contact from './Pages/Contact.jsx'
import ProductReview from './Pages/Products/ProductReview.jsx'
import ErrorPage from './Pages/ErrorPage.jsx'
import './css/index.css'
import { Toaster } from './lib/toast';
import ProductsData from "./lang/products.json";
import Corporate from "./Pages/Corporate.jsx";
import Dealership from "./Pages/Dealership.jsx";
import DealershipLanding from "./Pages/DealershipLanding.jsx";
import DealershipQuery from "./Pages/DealershipQuery.jsx";
import Support from "./Pages/Support.jsx";
import SupportRepairTracking from "./Pages/SupportRepairTracking.jsx";
import SupportWarranty from "./Pages/SupportWarranty.jsx";
import SupportAuthorizedService from "./Pages/SupportAuthorizedService.jsx";
import HumanResources from "./Pages/HumanResources.jsx";

let productPagePaths = []
async function loadProductData() {

  for (const key of Object.keys(ProductsData)) {
    if (ProductsData[key].link) {
      try {
        const data = await import(`./lang/products/${key}.json`);
        const jsonData = data.default;

        productPagePaths.push({
          path: ProductsData[key].link,
          element: (
            <ProductReview data={jsonData} />
          ),
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

}

async function setupRouterAndRender() {
  await loadProductData();
  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: <Home />,
        errorElement: <ErrorPage />
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "corporate",
        element: <Corporate />,
      },
      {
        path: "dealership",
        element: <DealershipLanding />,
      },
      {
        path: "dealership/application",
        element: <Dealership />,
      },
      {
        path: "dealership/query",
        element: <DealershipQuery />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "ik",
        element: <HumanResources />,
      },
      {
        path: "support/ariza-takip",
        element: <SupportRepairTracking />,
      },
      {
        path: "support/garanti-sorgulama",
        element: <SupportWarranty />,
      },
      {
        path: "support/yetkili-servisler",
        element: <SupportAuthorizedService />,
      },
      ...productPagePaths

    ]
  );

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <Toaster richColors position="top-right" />
      <RouterProvider router={router} />
    </React.StrictMode>,
  )

}
setupRouterAndRender()
